<template>
  <div class="loading-spin"></div>
</template>

<script>
export default {
  name: "LightSpinner"
};
</script>

<style lang="scss">
.loading-spin {
  display: inline-block;
  z-index: 99;
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  content: "";
  font-size: 10px;
  text-indent: -9999em;
  border-top: 3px solid rgba(0, 0, 0, 0.1) !important;
  border-right: 3px solid rgba(0, 0, 0, 0.1) !important;
  border-bottom: 3px solid rgba(0, 0, 0, 0.1) !important;
  opacity: 0.8;
  border-left: 3px solid #446084;
  animation: spin 0.6s infinite linear;
  pointer-events: none;
  box-sizing: border-box;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
